module.exports = __webpack_public_path__ + "img/alipay-logo.4fdd8c15.svg";